import dayjs, { Dayjs } from 'dayjs';
import { DIMENSION } from '../enum/common.enum';

export const getDayString = (date: string | number | Date) => {
  const dataObj = new Date(date);
  const add0 = (m: number) => (m < 10 ? `0${m}` : m);
  const year = dataObj.getFullYear();
  const month = dataObj.getMonth() + 1;
  const day = dataObj.getDate();
  return `${year}-${add0(month)}-${add0(day)}`;
};

export const getAllDay = (start: string | number, end: string | number, offset = 0) => {
  const startTime = new Date(start);
  const endTime = new Date(end);

  startTime.setDate(startTime.getDate() - offset);
  endTime.setDate(endTime.getDate() + offset);

  const dateArr: any = [];
  while (endTime.getTime() - startTime.getTime() >= 0) {
    dateArr.push(getDayString(startTime));
    startTime.setDate(startTime.getDate() + 1);
  }
  return dateArr;
};

export const getSnapshotDateStr = (date: string | Dayjs, dimension: DIMENSION) => {
  switch (dimension) {
    case DIMENSION.MONTH:
      return dayjs(date).format('YYYY-MM');
    case DIMENSION.WEEK:
      return dayjs(date).isoWeekday(1).format('YYYY-MM-DD');
    case DIMENSION.DAY:
      return dayjs(date).format('YYYY-MM-DD');
  }
};
